module.exports = __webpack_public_path__ + "img/4_96.b86b7530.png";